import { render, staticRenderFns } from "./PricelistTemplates.vue?vue&type=template&id=2d846456"
import script from "./PricelistTemplates.vue?vue&type=script&lang=js"
export * from "./PricelistTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports